import { Modal } from '@/components/ModalRenderer/Modal';

const today = new Date().toLocaleDateString('sv-SE', {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
});

const TermsAndConditionsPartner = () => (
  <Modal title="Allmänna villkor">
    <div className="flex flex-col gap-4">
      <p>Gäller från och med {today}</p>

      <h2 className="text-section-util">1. Allmän information</h2>
      <p>
        Dessa allmänna villkor (&quot;Allmänna Villkor&quot; eller &quot;Villkor&quot;) ingås mellan Fairlo
        AB, org.nr 559084-1101, Linnégatan 76, 115 23 Stockholm (&quot;Fairlo&quot; eller
        &quot;Kreditgivaren&quot;), och dig som kredittagare (&quot;Du&quot; eller &quot;Kredittagaren&quot;).
      </p>
      <p>
        Kreditgivaren tillhandahåller konsumentkrediter utan säkerhet till privatpersoner för betalning av
        fakturor och andra betalningsförpliktelser.
      </p>
      <p>
        Villkoren för Krediten framgår av Kreditavtalet, dessa Allmänna Villkor samt den betalningsplan som
        vid var tid gäller för Krediten (&quot;Betalningsplanen&quot;). Genom att ingå Kreditavtalet förbinder
        sig Kredittagaren att följa Kreditavtalet, dessa Allmänna villkor samt Betalningsplanen.
      </p>

      <h2 className="text-section-util">2. Definitioner</h2>
      <p>
        Med &quot;Kredit&quot; avses den kredit som Kredittagaren ansöker om och beviljas enligt
        Kreditavtalet.
      </p>
      <p>
        Med &quot;Kreditavtal&quot; avses det avtal som ingås mellan Kredittagaren och Kreditgivaren avseende
        Krediten.
      </p>
      <p>Med &quot;Kredittagare&quot; avses den fysiska person som ansöker om eller har beviljats Kredit.</p>
      <p>
        Med &quot;Kreditutrymme&quot; avses det högsta kreditbelopp som Kredittagaren vid var tid får utnyttja
        enligt Kreditavtalet.
      </p>
      <p>Med &quot;Kreditgivaren&quot; avses Fairlo AB, organisationsnummer 559084-1101.</p>
      <p>Med &quot;Betalningsplan&quot; avses den amorterings- och betalningsplan som gäller för Krediten.</p>
      <p>
        Med &quot;Månadsbelopp&quot; avses det belopp som Kredittagaren ska erlägga varje månad enligt
        Betalningsplanen.
      </p>
      <p>Med &quot;Extraamortering&quot; avses betalning som sker utöver ordinarie Månadsbelopp.</p>

      <h2 className="text-section-util">3. Om Krediten</h2>
      <p>
        Krediten är en kontokredit utan säkerhet som får användas för betalning av fakturor och andra
        betalningsförpliktelser som godkänns av Kreditgivaren.
      </p>
      <p>
        Krediten får endast användas för sådana betalningar som omfattas av Kreditavtalet och som godkänts av
        Kreditgivaren. Kreditgivaren avgör ensidigt vilka fakturor eller betalningsförpliktelser som kan
        betalas genom Krediten.
      </p>
      <p>
        Kreditutrymmet minskar i takt med att Krediten utnyttjas. Återbetalningar medför inte att återbetalt
        kreditutrymme automatiskt blir tillgängligt för nytt utnyttjande. Eventuellt nytt utnyttjande av
        tidigare återbetalt kreditutrymme förutsätter särskilt godkännande från Kreditgivaren.
      </p>
      <p>
        Kreditbelopp betalas inte ut direkt till Kredittagaren utan används för betalning av godkända fakturor
        eller betalningsförpliktelser.
      </p>

      <h2 className="text-section-util">4. Ansökan och ingående av kreditavtal</h2>
      <p>För att en Kredit ska kunna beviljas krävs att:</p>
      <ol className="list-[lower-alpha] pl-6" type="a">
        <li>Kredittagarens ansökan om Kredit har godkänts,</li>
        <li>Kredittagaren har lämnat de uppgifter och den dokumentation som efterfrågats,</li>
        <li>
          Kredittagarens kreditvärdighet inte har försämrats på ett sådant sätt att det påverkar möjligheten
          att bevilja eller använda Krediten, samt
        </li>
        <li>
          Kredittagaren:
          <ol className="mt-2 list-[lower-roman] pl-6" type="i">
            <li>är minst 20 år gammal,</li>
            <li>har svenskt personnummer,</li>
            <li>är folkbokförd i Sverige,</li>
            <li>har konto i svensk bank, och</li>
            <li>har giltigt personligt BankID.</li>
          </ol>
        </li>
      </ol>
      <p>Kreditgivaren har rätt att ställa ytterligare krav för att Kredit ska beviljas eller få användas.</p>
      <p>
        Återbetalning sker genom månatliga betalningar enligt den betalningsplan som presenteras för
        Kredittagaren vid Kreditavtalets ingående. Kredittagaren kan, i den utsträckning som vid var tid
        erbjuds av Kreditgivaren, ändra återbetalningsplanen via Mina Sidor. Ändring av återbetalningsplan kan
        påverka kredittid, månadsbelopp och den totala kreditkostnaden.
      </p>

      <h2 className="text-section-util">5. Ränta och avgifter</h2>
      <p className="text-body-semibold italic">Ränta på utbetald Kredit</p>
      <p>
        Tillämplig räntesats framgår av Kreditavtalet. Räntan är rörlig, vilket innebär att Kreditgivaren har
        rätt att ändra räntesatsen i den utsträckning det motiveras av kreditpolitiska beslut, ökade
        upplåningskostnader för Kreditgivaren eller andra kostnadsförändringar som Kreditgivaren inte skäligen
        kunde förutse när Kreditavtalet ingicks.
      </p>
      <p>
        Kredittagaren kommer att informeras om planerade ränteändringar och hur dessa påverkar Kredittagarens
        månadsbetalningar innan ändringarna börjar gälla.
      </p>
      <p className="text-body-semibold italic">Dröjsmålsränta och avgifter vid sen betalning</p>
      <p>
        Vid försenad betalning har Kreditgivaren rätt att debitera dröjsmålsränta på utestående belopp från
        förfallodagen till dess full betalning har kommit Kreditgivaren tillhanda.
      </p>
      <p>
        Kreditgivaren har även rätt att debitera påminnelseavgift med det belopp som anges i Kreditavtalet
        samt vid var tid gällande lagstadgade inkassokostnader.
      </p>
      <p>
        Om Kreditgivarens fordran överlämnas för indrivning till Kronofogdemyndigheten eller annan behörig
        myndighet eller domstol tillkommer vid var tid gällande lagstadgade kostnader och avgifter.
      </p>
      <p className="text-body-semibold italic">Avgift vid avsaknad av autogiromedgivande</p>
      <p>
        Om Kredittagaren återkallar sitt autogiromedgivande har Kreditgivaren enligt Kreditavtalet rätt att
        debitera en avgift till dess att Krediten har återbetalats i sin helhet.
      </p>

      <h2 className="text-section-util">6. Utbetalning av Krediten</h2>
      <p>
        Krediten används för betalning av fakturor eller andra betalningsförpliktelser som godkänts av
        Kreditgivaren. När sådan betalning genomförts blir motsvarande belopp en del av Kredittagarens skuld
        enligt Kreditavtalet. Kreditbelopp betalas inte ut direkt till Kredittagaren.
      </p>

      <h2 className="text-section-util">7. Återbetalning</h2>
      <p>
        Kredittagaren ska återbetala Krediten, ränta och eventuella avgifter enligt Betalningsplanen.
        Återbetalning sker genom betalning av Månadsbelopp. Månadsbeloppet består av amortering, ränta och i
        förekommande fall avgifter.
      </p>
      <p>
        Kredittagaren kan när som helst göra Extraamortering eller återbetala hela den utestående skulden utan
        extra kostnad utöver upplupen ränta. Vid Extraamortering justeras återstående skuld i enlighet med
        tillämplig Betalningsplan.
      </p>
      <p>
        Vid betalning av Krediten sker avräkning först mot förfallna avgifter, kostnader och räntor och
        därefter mot utestående kapitalskuld.
      </p>

      <h2 className="text-section-util">8. Betalning via autogiro</h2>
      <p>
        En förutsättning för att Kredittagaren ska kunna ingå Kreditavtalet är att Kredittagaren lämnar
        samtycke till betalning via autogiro genom särskilt autogiromedgivande.
      </p>
      <p>
        Betalning av Kredit, ränta samt eventuella avgifter och kostnader sker genom autogiro den 25:e i varje
        månad i enlighet med den vid var tid gällande betalningsplanen. Om förfallodagen inte infaller på en
        bankdag sker autogirodragningen bankdagen före förfallodagen.
      </p>
      <p>
        Det bankkonto som Kredittagaren har anslutit till autogiro debiteras med aktuellt månadsbelopp på
        förfallodagen.
      </p>
      <p>
        Om det saknas täckning på kontot vid dragningstillfället har Kreditgivaren rätt att göra ytterligare
        dragningsförsök under de närmast följande dagarna. Om betalning fortfarande inte kunnat genomföras har
        Kreditgivaren även rätt att göra nytt dragningsförsök den 10:e i månaden samt i samband med
        nästkommande ordinarie dragning.
      </p>
      <p>
        Om Kredittagaren inte ansluter autogiro har Kreditgivaren rätt att stoppa utbetalning av Kredit samt
        säga upp Kreditavtalet i enlighet med Avtalets villkor.
      </p>

      <h2 className="text-section-util">9. Avtalets varaktighet</h2>
      <p>
        Kreditavtalet träder i kraft när det har undertecknats av Kredittagaren och gäller till dess att
        Krediten har återbetalats i sin helhet eller Kreditavtalet annars upphör.
      </p>

      <h2 className="text-section-util">10. Sammanställning</h2>
      <p>
        Kredittagaren har rätt att, på begäran och utan kostnad, när som helst under löptiden för
        Kreditavtalet få en sammanställning i form av en tabell över återstående betalningar enligt Krediten.
      </p>
      <p>Sammanställningen ska innehålla uppgifter om:</p>
      <ol className="list-[lower-alpha] pl-6" type="a">
        <li>varje betalning som ska göras och respektive förfallodag,</li>
        <li>betalningsbelopp och eventuella villkor för betalningen, samt</li>
        <li>
          en specifikation av varje betalning som visar hur stor del som avser amortering, ränta respektive
          eventuella avgifter.
        </li>
      </ol>

      <h2 className="text-section-util">11. Förtida uppsägning</h2>
      <p>
        Kreditgivaren har rätt att säga upp Avtalet och begära betalning i förtid av samtliga utestående
        kreditbelopp inklusive upplupen ränta om:
      </p>
      <ol className="list-decimal pl-6">
        <li>
          Kredittagaren är mer än en månad försenad med betalning av ett belopp som överstiger tio procent (10
          %) av kreditfordran,
        </li>
        <li>
          Kredittagaren är mer än en månad försenad med betalning av ett belopp som överstiger fem procent (5
          %) av kreditfordran och förseningen avser två eller flera betalningar som förfaller vid olika
          tidpunkter,
        </li>
        <li>Kredittagaren på annat sätt är väsentligen försenad med betalning,</li>
        <li>
          det är uppenbart att Kredittagaren genom att undandra sig, avhända sig egendom eller genom annat
          agerande försöker undvika att betala sin skuld, eller
        </li>
        <li>
          någon av följande omständigheter föreligger och det därigenom finns risk för att Kredittagaren inte
          kommer att kunna fullgöra sina skyldigheter enligt Kreditavtalet, särskilt skyldigheten att
          återbetala Krediten:
          <ol className="mt-2 list-[lower-alpha] pl-6" type="a">
            <li>
              Kredittagaren har lämnat felaktiga uppgifter som varit av betydelse för Kreditgivarens beslut
              att ingå Avtalet,
            </li>
            <li>Kredittagaren avlider,</li>
            <li>Kredittagaren försätts i personlig konkurs eller blir föremål för skuldsanering, eller</li>
            <li>
              Kredittagaren underlåter att lämna information eller handlingar som Kreditgivaren skriftligen
              begär för att uppfylla skyldigheter enligt tillämplig penningtvättslagstiftning, inklusive krav
              avseende löpande kundkännedom.
            </li>
          </ol>
        </li>
      </ol>
      <p>
        Om Kreditgivaren vill kräva betalning i förtid enligt punkterna 1–3 ovan gäller en uppsägningstid om
        minst fyra veckor från det att meddelande om uppsägning skickats till Kredittagaren genom
        rekommenderat brev eller från den tidpunkt då uppsägningen på annat sätt kommit Kredittagaren
        tillhanda.
      </p>
      <p>
        Kredittagaren är dock inte skyldig att betala i förtid om det belopp som förfallit till betalning
        regleras innan uppsägningstidens utgång. Detta gäller inte om Kredittagaren tidigare har befriats från
        skyldigheten att betala Krediten i förtid på sådan grund.
      </p>
      <p>
        Kreditgivaren kommer att informera Kredittagaren skriftligen om uppsägning av Avtalet. När meddelandet
        om uppsägning kommit Kredittagaren tillhanda förfaller samtliga utestående kreditbelopp till
        betalning.
      </p>

      <h2 className="text-section-util">12. Ändringar</h2>
      <p>
        Kreditgivaren har rätt att ändra räntesatsen för Krediten i den utsträckning det motiveras av
        kreditpolitiska beslut, ändrade upplåningskostnader för Kreditgivaren eller andra kostnadsförändringar
        som Kreditgivaren inte rimligen kunde förutse när Krediten beviljades. Motsvarande ändringar ska även
        tillämpas till Kredittagarens fördel när omständigheterna motiverar det.
      </p>
      <p>
        Utöver vad som anges ovan har Kreditgivaren rätt att göra ändringar i dessa Allmänna Villkor utan
        Kredittagarens samtycke, under förutsättning att ändringarna inte påverkar Kredittagarens
        betalningsförpliktelser. Sådana ändringar träder i kraft två månader efter att Kredittagaren har
        informerats skriftligen om ändringarna.
      </p>
      <p>
        Om Kredittagaren inte godkänner ändringarna har Kredittagaren rätt att säga upp Avtalet med omedelbar
        verkan genom att återbetala samtliga utestående belopp senast den dag då ändringarna träder i kraft.
        Några ytterligare kostnader till följd av uppsägningen kommer i sådant fall inte att tas ut.
      </p>
      <p>
        Uppsägning enligt detta avsnitt kan skickas till{' '}
        <a className="link" href="mailto:kundservice@fairlo.se">
          kundservice@fairlo.se
        </a>
        .
      </p>

      <h2 className="text-section-util">13. Ångerrätt</h2>
      <p>
        Kredittagaren har rätt att frånträda Kreditavtalet genom att utöva sin ångerrätt inom 14 dagar från
        den dag då Avtalet ingicks. Ångerfristen börjar dock löpa tidigast den dag då Kredittagaren har
        mottagit avtalsvillkoren.
      </p>
      <p>
        För att utöva ångerrätten ska Kredittagaren skriftligen meddela Kreditgivaren sin avsikt att frånträda
        Avtalet. Meddelandet ska skickas till{' '}
        <a className="link" href="mailto:kundservice@fairlo.se">
          kundservice@fairlo.se
        </a>
        .
      </p>
      <p>
        Om Kredittagaren utövar sin ångerrätt ska hela det utnyttjade kreditbeloppet återbetalas tillsammans
        med upplupen ränta från dagen då Krediten utnyttjades till och med dagen för återbetalning.
      </p>
      <p>
        Återbetalning ska ske utan onödigt dröjsmål och senast inom 30 kalenderdagar från den dag då
        meddelandet om frånträdande skickades.
      </p>

      <h2 className="text-section-util">14. Elektronisk kommunikation och ändring av uppgifter</h2>
      <p>
        Genom att samtycka till elektronisk kommunikation godkänner Kredittagaren att Kreditgivaren får skicka
        kontoutdrag, meddelanden och annan information som avser eller har samband med Kreditavtalet via
        e-post till den e-postadress eller via sms till det telefonnummer som Kredittagaren har registrerat.
        Detta gäller dock inte sådan kommunikation som enligt lag måste lämnas i pappersform.
      </p>
      <p>
        Kredittagaren ansvarar för att de kontaktuppgifter som lämnats till Kreditgivaren är korrekta och
        aktuella. Kredittagaren ska utan dröjsmål informera Kreditgivaren om ändringar av namn, adress,
        e-postadress eller telefonnummer samt, på begäran, lämna handlingar eller annan information som
        styrker ändringen.
      </p>

      <h2 className="text-section-util">15. Kreditprövning och kreditupplysningar</h2>
      <p>
        När Kredittagaren ansöker om Kredit kommer Kreditgivaren att bedöma Kredittagarens kreditvärdighet för
        att avgöra om Kredit kan beviljas samt fastställa eventuell kreditlimit.
      </p>
      <p>
        Kredittagaren är skyldig att lämna den information och dokumentation som Kreditgivaren begär för att
        kreditprövning ska kunna genomföras. Om det senare visar sig att Kredittagaren avsiktligen har lämnat
        felaktiga uppgifter eller undanhållit information eller dokumentation av betydelse för
        kreditprövningen har Kreditgivaren rätt att säga upp Kreditavtalet.
      </p>
      <p>
        Om en kreditupplysning tas kan Kredittagaren informeras via e-post eller genom Mina Sidor.
        Kreditupplysningsföretag registrerar uppgifter om genomförda kreditupplysningar, oavsett om Kredit
        beviljas eller inte. Sådana registreringar kan vara synliga för tredje part och kan påverka framtida
        kreditbedömningar.
      </p>
      <p>
        Kreditgivaren kan även komma att lämna uppgifter till kreditupplysningsföretag och relevanta
        skuldregister avseende bland annat beviljade Krediter, betalningar, försenade betalningar, utestående
        skulder samt uppsägning av Kredit.
      </p>
      <p>
        Ytterligare information om hur personuppgifter och kreditinformation behandlas finns i Kreditgivarens
        dataskyddsinformation.
      </p>

      <h2 className="text-section-util">16. Behandling av personuppgifter</h2>
      <p>
        Kreditgivaren är personuppgiftsansvarig för behandlingen av personuppgifter som sker i samband med
        Kreditavtalet. Personuppgifter behandlas i enlighet med vid var tid gällande dataskyddslagstiftning
        för att:
      </p>
      <ul className="list-disc pl-6">
        <li>administrera och fullgöra Kreditavtalet,</li>
        <li>genomföra kreditprövning,</li>
        <li>hantera betalningar och kundservice,</li>
        <li>
          uppfylla rättsliga skyldigheter, inklusive skyldigheter enligt penningtvättslagstiftning, samt
        </li>
        <li>i övrigt tillvarata berättigade intressen kopplade till Kreditgivarens verksamhet.</li>
      </ul>
      <p>
        Personuppgifter kan komma att delas med samarbetspartners, leverantörer, kreditupplysningsföretag,
        myndigheter och andra mottagare när det är nödvändigt för att fullgöra Kreditavtalet eller uppfylla
        rättsliga skyldigheter.
      </p>
      <p>
        Information om hur Kreditgivaren samlar in, behandlar, lagrar och delar personuppgifter, inklusive
        information om ändamål, rättslig grund, lagringstid, registrerades rättigheter och automatiserade
        beslut, finns i Kreditgivarens integritetspolicy{' '}
        <a className="link" href="https://fairlo.se/privacy" target="_blank" rel="noopener noreferrer">
          https://fairlo.se/privacy
        </a>
      </p>

      <h2 className="text-section-util">17. Meddelanden</h2>
      <p>
        Kredittagaren ansvarar för att hålla sina kontaktuppgifter uppdaterade. Om Kredittagaren ändrar namn,
        e-postadress eller telefonnummer ska detta utan dröjsmål meddelas Kreditgivaren genom Mina Sidor på{' '}
        <a className="link" href="http://www.fairlo.se" target="_blank" rel="noopener noreferrer">
          www.fairlo.se
        </a>{' '}
        eller på annat sätt som Kreditgivaren anvisar.
      </p>
      <p>
        Genom att ingå Kreditavtalet samtycker Kredittagaren till att Kreditgivaren får skicka information,
        meddelanden och annan kommunikation som avser Avtalet via e-post, sms eller annat elektroniskt
        kommunikationssätt som är anpassat för individuell kommunikation.
      </p>
      <p>
        Elektroniska meddelanden anses ha kommit Kredittagaren tillhanda när de har skickats till de
        kontaktuppgifter som Kredittagaren senast har registrerat hos Kreditgivaren.
      </p>

      <h2 className="text-section-util">18. Överlåtelse</h2>
      <p>
        Kredittagaren får inte utan Kreditgivarens skriftliga samtycke överlåta eller på annat sätt överföra
        sina rättigheter eller skyldigheter enligt Kreditavtalet.
      </p>
      <p>
        Kreditgivaren har rätt att överlåta eller pantsätta samtliga eller delar av de fordringar som
        uppkommer enligt Kreditavtalet, inklusive rätten till ränta och avgifter hänförliga till sådana
        fordringar.
      </p>
      <p>
        Om inte annat meddelas kommer Kreditgivaren även efter en sådan överlåtelse eller pantsättning att
        fortsätta administrera och hantera fordringarna för förvärvarens eller panthavarens räkning.
      </p>

      <h2 className="text-section-util">19. Begränsning av ansvar</h2>
      <p>
        Kreditgivaren ansvarar inte för skada som beror på lagbud, myndighetsåtgärd, krigshändelse, strejk,
        lockout, blockad, bojkott eller annan omständighet utanför Kreditgivarens kontroll. Förbehållet
        avseende strejk, lockout, blockad och bojkott gäller även om Kreditgivaren själv är föremål för eller
        vidtar sådan konfliktåtgärd. Kreditgivaren ansvarar inte för indirekt skada, om inte annat följer av
        tvingande lag. Om hinder föreligger för Kreditgivaren att verkställa betalning eller vidta annan
        åtgärd på grund av en sådan omständighet som anges ovan får åtgärden skjutas upp till dess att hindret
        har upphört.
      </p>

      <h2 className="text-section-util">20. Tillsynsmyndighet</h2>
      <p>
        Finansinspektionen, Box 7821, 103 97 Stockholm,{' '}
        <a className="link" href="http://www.fi.se" target="_blank" rel="noopener noreferrer">
          www.fi.se
        </a>
        , utövar tillsyn över Kreditgivaren.
      </p>
      <p>
        Konsumentverket, Box 48, 651 02 Karlstad,{' '}
        <a className="link" href="http://www.konsumentverket.se" target="_blank" rel="noopener noreferrer">
          www.konsumentverket.se
        </a>
        , utövar tillsyn över Kreditgivaren avseende efterlevnad av marknadsföringslagstiftningen.
      </p>

      <h2 className="text-section-util">21. Klagomål</h2>
      <p>
        Om Kredittagaren har klagomål avseende Kreditgivarens tjänster bör Kredittagaren i första hand
        kontakta Kreditgivarens kundservice via{' '}
        <a className="link" href="http://www.fairlo.se" target="_blank" rel="noopener noreferrer">
          www.fairlo.se
        </a>{' '}
        eller e-post till{' '}
        <a className="link" href="mailto:kundservice@fairlo.se">
          kundservice@fairlo.se
        </a>
        .
      </p>
      <p>
        Om Kredittagaren efter kontakt med kundservice fortfarande inte är nöjd kan ett skriftligt klagomål
        lämnas till Kreditgivarens kundombudsman via e-post till{' '}
        <a className="link" href="mailto:kundombud@fairlo.se">
          kundombud@fairlo.se
        </a>
        . Information om Kreditgivarens klagomålshantering samt formulär för klagomål finns på{' '}
        <a className="link" href="http://www.fairlo.se" target="_blank" rel="noopener noreferrer">
          www.fairlo.se
        </a>
        .
      </p>
      <p>
        Kreditgivaren hanterar klagomål i enlighet med Finansinspektionens allmänna råd om klagomålshantering
        avseende finansiella tjänster till konsumenter.
      </p>
      <p>Kredittagaren kan även få kostnadsfri vägledning från:</p>
      <ul className="list-disc pl-6">
        <li>Konsumenternas Bank- och finansbyrå,</li>
        <li>Konsumenternas Försäkringsbyrå, samt</li>
        <li>den kommunala konsumentvägledningen.</li>
      </ul>
      <p>
        Om en tvist inte kan lösas mellan parterna har Kredittagaren möjlighet att vända sig till Allmänna
        reklamationsnämnden (ARN), Box 174, 101 23 Stockholm,{' '}
        <a className="link" href="http://www.arn.se" target="_blank" rel="noopener noreferrer">
          www.arn.se
        </a>
        .
      </p>

      <h2 className="text-section-util">22. Tillämplig lag och tvister</h2>
      <p>Kreditavtalet ska tolkas och tillämpas i enlighet med svensk rätt.</p>
      <p>
        Tvister med anledning av Kreditavtalet ska avgöras av svensk domstol, om inte annat följer av
        tvingande lag.
      </p>
      <p>
        Kreditgivaren har dock rätt att väcka talan vid annan behörig domstol eller myndighet utanför Sverige
        i den utsträckning det är tillåtet enligt tillämplig lag.
      </p>
    </div>
  </Modal>
);

export default TermsAndConditionsPartner;
